// src/pages/About.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; 
import { collection, getDocs } from 'firebase/firestore';
import './AboutPage.css';

const About = () => {
  const [homeMealCategory, setHomeMealCategory] = useState(null);
  const [dietPlanCategory, setDietPlanCategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "categories"));
        const categoriesData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        const homeMeal = categoriesData.find(cat => cat.name === 'Home Meal');
        const dietPlan = categoriesData.find(cat => cat.name === 'Diet Plan');

        setHomeMealCategory(homeMeal);
        setDietPlanCategory(dietPlan);

      } catch (error) {
        console.error("Error fetching categories from Firestore: ", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="about-us-page">
      {/* --- 1. Hero Section --- */}
      <section className="about-hero-section">
        <div className="hero-content">
          <span className="hero-subtitle">ABOUT US</span>
          <h1 className="hero-title">Toven is India's First Pre-Order, Only Food ecosystem</h1>
          <p className="hero-description">
            crafted to make everyday eating fresh, flexible, and wholesome. With homemade-quality meals, fitness diets, add-ons, and party orders, we deliver food that fits your lifestyle — backed by customizable plans, premium packing, and on-time delivery. At TOVEN, every bite is made just for you.
          </p>
          <div className="hero-icons">
            <span>🕒 Homemade Quality</span>
            <span>🛍️ Premium Packing</span>
            <span>🍴 On-time Delivery</span>
          </div>
        </div>
      </section>

      {/* --- Wrapper for content below the curve --- */}
      <div className="main-content-wrapper">
        <section className="story-section">
          <h2>Why We Started?</h2>
          <p>TOVEN was created to solve the everyday struggle of finding meals that are fresh, healthy, and truly satisfying. Mess food often feels repetitive, restaurant food leans unhealthy, and most cloud kitchens miss the personal touch. We started TOVEN to bring back the comfort of wholesome, homely meals cooked with care, delivered on time, and designed to fit modern lifestyles.
</p>
        </section>

        <section className="story-section">
          <h2>What Makes Us Different?</h2>
          <div className="features-showcase">
            <div className="feature-card">
              <div className="feature-icon">🍽️</div>
              <h3>Pre-Order Only Model</h3>
              <p>Fresh meals prepared just for you, with zero waste.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏠</div>
              <h3>Homemade Quality</h3>
              <p>Every dish is cooked with care, bringing you comfort and taste like home.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚙️</div>
              <h3>Customized Meal Plans</h3>
              <p>Choose your meals, portions, and preferences exactly how you like.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🥗</div>
              <h3>Add-Ons & Sides</h3>
              <p>Complete your meal with extra portions and tasty sides, tailored to your appetite.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📅</div>
              <h3>Flexible Scheduling</h3>
              <p>Pause, resume, or reschedule your meals whenever you need.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🚚</div>
              <h3>On-Time Delivery</h3>
              <p>Your food, delivered fresh and right on schedule.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📦</div>
              <h3>Premium Packing</h3>
              <p>Hygienic, spill-proof, and eco-conscious packaging for a clean experience.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💪</div>
              <h3>Daily & Fitness Meals</h3>
              <p>Whether it's simple homely food or fitness-focused diets, we've got you covered.</p>
            </div>
          </div>
        </section>
      </div>

      {/* --- 3. What We Offer Section --- */}
      <section className="what-we-offer">
        <div className="container">
          <h2 className="section-title">What We Offer</h2>
          <div className="offer-grid">
            {/* Home Meal Card */}
            <div className="product-wrapper">
              <div className="card-image-top">
                <img src="/assets/images/homepage-one/home-meal.png" alt="Home Meal" />
              </div>
              <div className="wrapper-info">
                <h3 className="wrapper-details">Home Meal</h3>
                <h5 className="wrapper-details">Daily deliciousness</h5>
              
                <Link 
                  to={homeMealCategory ? `/category/${homeMealCategory.id}/meals` : "/package"} 
                  className="order-now-btn"
                >
                  Order now
                </Link>
              </div>
            </div>

            {/* Fitness & Diet Meal Card */}
            <div className="product-wrapper">
              <div className="card-image-top">
                <img src="/assets/images/homepage-one/diet-plan.png" alt="Fitness & Diet Meal" />
              </div>
              <div className="wrapper-info">
                <h3 className="wrapper-details">Fitness & Diet Meal</h3>
                <h5 className="wrapper-details">Meals that heal</h5>
                
                <Link 
                  to={dietPlanCategory ? `/category/${dietPlanCategory.id}/meals` : "/package"} 
                  className="order-now-btn"
                >
                  Order now
                </Link>
              </div>
            </div>

            {/* Party Orders Card */}
            <div className="product-wrapper">
              <div className="card-image-top">
                <img src="/assets/images/homepage-one/party-orders.png" alt="Party Orders" />
              </div>
              <div className="wrapper-info">
                <h3 className="wrapper-details">Party Orders</h3>
                <h5 className="wrapper-details">Your Feast, Party</h5>
                
                <Link to="/party-orders" className="order-now-btn">
                  Order now
                </Link>
              </div>
            </div>

            {/* Add-ons & Side Dish Card */}
            <div className="product-wrapper">
              <div className="card-image-top">
                <img src="/assets/images/homepage-one/add-ons.png" alt="Add-ons & Side Dish" />
              </div>
              <div className="wrapper-info">
                <h3 className="wrapper-details">Add-ons & Side Dish</h3>
                <h5 className="wrapper-details">Complete your meal</h5>
                
                <Link to="/addons" className="order-now-btn">
                  Order now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* --- 4. Vision & Mission Section --- */}
      <section className="vision-mission-section">
        <div className="container">
            <div className="vm-grid">
                <div className="vm-card">
                    <h3>Our Vision</h3>
                    <p>To be the most trusted and beloved provider of homemade meals, creating a healthy and happy food culture in every community we serve.</p>
                </div>
                <div className="vm-card">
                    <h3>Our Mission</h3>
                    <p>To empower home chefs and make healthy, delicious, and convenient homemade food accessible to everyone through a sustainable pre-order platform.</p>
                </div>
            </div>
        </div>
      </section>

    </div>
  );
};

export default About;